import { apiClient } from './axios'

export const getDynamics = async (key) => {
  try {
    const response = await apiClient.get(`api/dynamics/${key}`)
    return response.data
  } catch (error) {
    console.error('Error fetching dynamic content:', error)
    return null
  }
}

export const putDynamics = async (key, content) => {
  try {
    const response = await apiClient.put(`api/dynamics/${key}`, { content })
    return response.data
  } catch (error) {
    console.error('Error updating dynamic content:', error)
    return false
  }
}
